import PropertyListingCard from '@components/Card/PropertyListingCard';
import { color } from '@design/templateFns';
import { FC } from 'react';
import styled from 'styled-components';

interface PropertyListingCardSkeletonProps {
  id: string;
}

const PropertyListingCardSkeleton: FC<PropertyListingCardSkeletonProps> = ({ id }) => {
  return (
    <StyledPropertyListingCard
      id={id}
      listOfficeMlsId="123"
      imgs={[]}
      listPrice={1000000}
      address={`123 Main St, Anytown, USA`}
      propertyType={`Home`}
      bathrooms={`1`}
      bedrooms={`1`}
      squareFootage={`1`}
      acreage={`1`}
      listOfficeName={`Engel & Völkers`}
      listingStatus={`Active`}
      originatingSystemName={`EVAMLS`}
      listUrl="#"
      propertySubType="Single Family"
      country="USA"
      currencyCode="USD"
    />
  );
};

export default PropertyListingCardSkeleton;

const StyledPropertyListingCard = styled(PropertyListingCard)`
  h3,
  li,
  span {
    color: ${color('gray2')};
  }
  button {
    opacity: 0.25;
  }
`;
